import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import DocumentMeta from 'react-document-meta';
import TermsText from '../static/da/terms';

@i18n
class Terms extends Component {
  render() {
    const docMeta = {
      title: this.i18n('Terms of use'),
      extend: true,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta}>
        <Grid>
          <Row>
            <Col xs={12}>{TermsText}</Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default Terms;
